export default "__VITE_ASSET__BASn8Moi__"